/**
 * The shape of the body a webhook receives (PREC-4251), stored per webhook as `payloadVersion`.
 *
 * - **1** — the bare export row array, exactly as every webhook received it before PREC-4251.
 *   Every webhook that existed when the column was added keeps it, so n8n, Make and Supabase
 *   functions built on the array keep working.
 * - **2** — one envelope object per delivery: delivery id, event type, time, webhook and list
 *   around the lead row. A webhook created from now on starts here.
 *
 * The web pre-selects `NEW_WEBHOOK_PAYLOAD_VERSION` in the Create Webhook dialog and the API
 * applies it when a create names no version, so both read it from here.
 */

export const WEBHOOK_PAYLOAD_VERSIONS = [1, 2] as const;

export type WebhookPayloadVersion = (typeof WEBHOOK_PAYLOAD_VERSIONS)[number];

/** The version a newly created webhook gets when the request names none. */
export const NEW_WEBHOOK_PAYLOAD_VERSION: WebhookPayloadVersion = 2;

/** The legacy array body; also what a webhook whose stored version is unreadable receives. */
export const LEGACY_WEBHOOK_PAYLOAD_VERSION: WebhookPayloadVersion = 1;

export function isWebhookPayloadVersion(value: unknown): value is WebhookPayloadVersion {
	return (WEBHOOK_PAYLOAD_VERSIONS as readonly unknown[]).includes(value);
}
